<header id="page-header" class="clearfix">
		<div class="container-fluid">
	  <div class="row-fluid">

				<div class="span12">
			<div class="logo-header">
				<a class="logo" href="http://aulavirtual.bnp.edu.pe" title="Página Principal">
					<img src="assets/image/admin/LogoAulaVirtual.png" class="img-responsive" alt="logo" style="margin: 0 auto;display: block;">				</a>

			</div>
		</div>


	</div>
</div>
</header>

<header role="banner" class="navbar" style="padding: 0;">
  <nav role="navigation" class="navbar-inner">
      <div class="container-fluid">
        <a class="brand" href="http://aulavirtual.bnp.edu.pe">Página Principal</a>
      </div>
  </nav>
</header>

<div class="container" style="padding-right: 5px;padding-left: 5px;">
<br>
<mdb-card>
  <mdb-card-header style="background-color: #f1f0f0;">
  Verifique la informacion de la Constancia
  </mdb-card-header>
  <mdb-card-body>

    <div class="form-row align-items-center">
      <div class="form-group col-md-2">
        Numero de Constancia:
        </div>
        <div class="form-group col-md-3">
          <input type="text" id="txtNro" [attr.disabled]="b_esnro ? null : true" [(ngModel)]="nroconstancia" class="form-control" mdbInput placeholder="Nro de constancia" (change)="onEscribeNro()">
        </div>
    </div>

    <div class="form-row align-items-center">
      <div class="form-group col-md-2">
        Nombres y Apellidos:
        </div>
        <div class="form-group col-md-3">
          <input type="text" id="txtNombres"  [attr.disabled]="b_esnombres ? null : true" [(ngModel)]="nombres" class="form-control" mdbInput placeholder="Nombres y Apellidos" (change)="onEscribeNombres()">
        </div>
    </div>


    <div class="form-row align-items-center">
      <div class="form-group col-md-2">
        Fecha Constancia :
       </div>
     <div class="form-group col-md-2">
       <input type="date" id="txtFechaNombres" maxlength="10" min="2022-01-01" max="2030-12-31" [(ngModel)]="fecha" class="form-control" mdbInput>
     </div>
    </div>

    <div class="form-row align-items-center">
      <div class="form-group col-md-2">
       </div>

        <button mdbBtn type="button" id="btnBuscar" (click)="Verificar()" size="md" color="blue" mdbWavesEffect>
        <mdb-icon fas icon="search" class="mr-1"></mdb-icon>Buscar</button>


        <button mdbBtn type="button" id="btnLimpiar" (click)="Limpiar()" size="sm" color="blue-grey" mdbWavesEffect>
          <mdb-icon fas icon="times" class="mr-1"></mdb-icon>Limpiar</button>

    </div>

  </mdb-card-body>
</mdb-card>
<br>

<mdb-card *ngIf="resultadook">
  <mdb-card-header style="background-color: #e5fbd9;">
    INFORMACION DE LA CONSTANCIA
  </mdb-card-header>
  <mdb-card-body>
    <div class="form-row align-items-center">
      <div class="form-group col-md-2">Numero de Constancia:</div>
      <div class="form-group col-md-3">{{res_nro}}    </div>
    </div>
    <div class="form-row align-items-center">
      <div class="form-group col-md-2">Nombres y Apellidos:</div>
      <div class="form-group col-md-3">{{res_nombres}}</div>
    </div>
    <div class="form-row align-items-center">
      <div class="form-group col-md-2">Curso:         </div>
      <div class="form-group col-md-6">{{res_curso}}  </div>
    </div>
    <div class="form-row align-items-center">
      <div class="form-group col-md-2">Fecha:         </div>
      <div class="form-group col-md-3">{{res_fecha}}  </div>
    </div>
    <div class="form-row align-items-center">
      <div class="form-group col-md-2">Nota:          </div>
      <div class="form-group col-md-3">{{res_nota}}   </div>
    </div>
  </mdb-card-body>
</mdb-card>
<mdb-card *ngIf="resultadoerror">
  <mdb-card-header style="background-color: #fbdcdc;color: rgb(88, 5, 5);">
    NO SE ENCONTRO LA CONSTANCIA
  </mdb-card-header>
</mdb-card>
</div>
